var file_upload_widget = {
    selector: '.syn-upload',
    inited: false,
    click_event: function(dom){
        var $parent = $(dom).closest('.syn-upload');
        var $input = $parent.find('input[type="file"]');
        $input.trigger('click');
    },
    change_event: function(dom, evt){
        var file_list = evt.target.files;
        var $parent = $(dom).closest('.syn-upload');
        $parent.trigger('file_upload_widget:change', {file_list: file_list, original_dom: dom});
    },
    cancel_event: function(dom){
        var $parent = $(dom).closest('.syn-upload');
        $parent.trigger('file_upload_widget:cancel');
    },
    handle_drop: function(evt){
        evt.preventDefault();
        evt.stopPropagation();
        var file_list = evt.originalEvent.dataTransfer.files;
        var $parent = $(evt.target).closest('.syn-upload');
        var $input = $parent.find('input[type="file"]');
        var allowed_types = $input.attr('accept');
        var allowed_types_array = allowed_types.split(', ');
        var allowed_types_regex = new RegExp(allowed_types_array.join('|'));
        var invalid_files = [];
        for(var i = 0; i < file_list.length; i++){
            if(!allowed_types_regex.test(file_list[i].type)){
                invalid_files.push(file_list[i].name);
            }
        }
        if(invalid_files.length){
            dialog_controller.display_dialog({'title': 'Error', 'content': 'Invalid file(s): ' + invalid_files.join(', ') + '<br><br>Please upload only the allowed file type(s):<br>' + allowed_types,
                'controls': [{text: 'OK', callback: function(){
                    dialog_controller.close_closest_dialog(this);
                    $parent.trigger('file_upload_widget:invalid_file_type', {file_list: file_list, original_dom: evt.target});
                }}]
            });
            return;
        }
        $input.prop('files', file_list);
        $parent.trigger('file_upload_widget:change', {file_list: file_list, original_dom: evt.target});
    },
    init: function(){
        var self = this;

        if(
            !$(self.selector).length
            || self.inited
        ){
            return;
        }
        $(document).on('click', self.selector + ' button', function(){
            self.click_event(this);
        });
        $(document).on('change', self.selector + ' input[type="file"]', function(evt){
            self.change_event(this, evt);
        });
        $(document).on('cancel', self.selector + ' .input[type="file"]', function(){
            self.cancel_event(this);
        });
        $(document).on('dragover', self.selector, function(evt){
            evt.preventDefault();
            evt.stopPropagation();
            jQuery(this).addClass('dragover');
        });
        $(document).on('dragleave', self.selector, function(evt){
            evt.preventDefault();
            evt.stopPropagation();
            jQuery(this).removeClass('dragover');
        });
        $(document).on('drop', self.selector, function(evt){
            jQuery(this).removeClass('dragover');
            self.handle_drop(evt);
        });

        self.inited = true;
    }
};

window.file_upload_widget = file_upload_widget;

jQuery(document).ready(function($){
    file_upload_widget.init();
});